import { withNamespaces } from 'react-i18next';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Divider from '@material-ui/core/Divider';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import FeedbackIcon from '@material-ui/icons/Feedback';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import LockIcon from '@material-ui/icons/Lock';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ExternalLink } from './ExternalLink';
// import { NoEmitOnErrorsPlugin } from 'webpack';

const avatarStyles = {
  height: '1.4em',
  width: '1.4em',
  fill: '#3D3D3D',
};

const listItemIconStyles = {
  fill: '#3D3D3D',
};

const iconContainerStyles = {
  marginRight: '-56px',
};

const styles = (theme) => ({
  divider: {
    marginBottom: '4px',
    marginTop: '4px',
  },
  email: {
    fontSize: '0.9em',
  },
  name: {
    fontWeight: 'bold',
    fontSize: '1.125em',
    marginBottom: '2px',
  },
  root: {
    width: 300,
  },
  userData: {
    lineHeight: 1.3,
    marginRight: '1em',
    marginTop: '-8px',
    '& $name, & $email': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  },
});

const UserMenu = ({
  anchorEl,
  classes,
  logout,
  open,
  onClose,
  user,
  userName,
  openDialog,
  updatedEmail,
  t,
  ...props
}) => {
  const userAgent = window.navigator.userAgent;
  const isDesktopApp = userAgent.match(/\PlutoTV\b.*\Electron\b/g);
  const desktopAppClickHandler = () => {
    window.open('https://support.pluto.tv/hc/en-us/requests/new');
    onClose();
  };

  return (
    <Menu {...{ anchorEl, onClose, open }} MenuListProps={{ className: classes.root }}>
      <MenuItem className={classes.divider}>
        <ListItemText
          primary={
            <div className={classes.userData}>
              <div className={classes.name}>{userName}</div>
              <div className={classes.email}>{updatedEmail ? updatedEmail : user.email}</div>
            </div>
          }
        />
        <ListItemSecondaryAction>
          <IconButton aria-label="Change avatar">
            <AccountCircleIcon style={avatarStyles} />
          </IconButton>
        </ListItemSecondaryAction>
      </MenuItem>
      <Divider className={classes.divider} />

      <MenuItem onClick={(e) => openDialog(e, 'updateEmail')}>
        <ListItemIcon style={iconContainerStyles}>
          <MailIcon style={listItemIconStyles} />
        </ListItemIcon>
        <ListItemText inset primary={t('update_email', 'Update Email')} />
      </MenuItem>
      <Divider className={classes.divider} />

      <MenuItem onClick={(e) => openDialog(e, 'changePassword')}>
        <ListItemIcon style={iconContainerStyles}>
          <LockIcon style={listItemIconStyles} />
        </ListItemIcon>
        <ListItemText inset primary={t('change_password', 'Change Password')} />
      </MenuItem>
      <Divider className={classes.divider} />

      {isDesktopApp ? (
        <MenuItem onClick={desktopAppClickHandler}>
          <ListItemIcon style={iconContainerStyles}>
            <FeedbackIcon style={listItemIconStyles} />
          </ListItemIcon>
          <ListItemText inset primary={t('send_feedback', 'Send Feedback')} />
        </MenuItem>
      ) : (
        <MenuItem
          component={ExternalLink}
          to="//support.pluto.tv/hc/en-us/requests/new"
          onClick={onClose}
        >
          <ListItemIcon style={iconContainerStyles}>
            <FeedbackIcon style={listItemIconStyles} />
          </ListItemIcon>
          <ListItemText inset primary={t('send_feedback', 'Send Feedback')} />
        </MenuItem>
      )}
      <Divider className={classes.divider} />

      <MenuItem onClick={(e) => openDialog(e, 'confirmLogout')}>
        <ListItemIcon style={iconContainerStyles}>
          <ExitToAppIcon style={listItemIconStyles} />
        </ListItemIcon>
        <ListItemText inset primary={t('logout', 'Logout')} />
      </MenuItem>
    </Menu>
  );
};
UserMenu.propTypes = {
  anchorEl: PropTypes.shape({}),
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  hasChatUser: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  openDialog: PropTypes.func.isRequired,
  openDialogOnDevices: PropTypes.func.isRequired,
  openDialogChatSettings: PropTypes.func.isRequired,
  user: PropTypes.shape({}).isRequired,
  userName: PropTypes.string.isRequired,
};
UserMenu.defaultProps = {
  anchorEl: null,
};

export const UserMenuComponent = withStyles(styles)(withNamespaces()(UserMenu));
